import React from 'react';
import Hightcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import treemap from 'highcharts/modules/treemap'; // treemap 모듈 로드

const ChartTreemap = ({chartData, title}) => {
	if (chartData == undefined || chartData.length == 0) {
		return
	}

	treemap(Hightcharts); // Highcharts에 treemap 모듈 등록

	const optionsBar = {
		series: [{
			type: 'treemap',
			data: chartData,
		}],
		title: {
			text: title,
			style : {
				color : '#000',
				fontSize : "14px",
				fontWeight : "bold"
			}
		},
	};

	return (
		<>
			<HighchartsReact highcharts={Hightcharts} options={optionsBar} containerProps={{ style: {width:'100%' , height: "90%" } }}/>
		</>
	);
};

export default ChartTreemap;